import {
  Airline,
  EnvironmentUx,
  Platform,
  TestPage,
} from '../models/index';

export const testPageUrl = 'https://1a.dgp-live.dgp-app-ci.nce2.paas.amadeus.net/refx-test-page-00010000/';

const testPageInfo: Record<string, TestPage> = {
  uxSsciTestPageConfig: {
    airLine: Airline.UX,
    platform: Platform['v6.1'],
    environment: EnvironmentUx['UAT SSCI(UX)']
  }
};

export const uxSsciTestPageConfig = testPageInfo.uxSsciTestPageConfig;
